import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["messagesContainer", "container"];

  toggleVisibility(event) {
    this.containerTarget.classList.toggle("hidden", event.target.value === "0");
  }

  addMessage(event) {
    event.preventDefault();
    const template = document
      .getElementById("prevent-transfer-message-template")
      .content.cloneNode(true);
    this.messagesContainerTarget.appendChild(template);
  }

  removeMessage(event) {
    event.preventDefault();
    event.target.closest(".prevent-transfer-message-item").remove();
  }
}
